module.exports = __webpack_public_path__ + "static/media/smith-family.b1e1d58a.PNG";